import React, { useEffect, useState } from "react";
import NavBarNotificationBar from "./AppAdminComponents/NavBarNotificationBar";
import AsideLeft from "./AppAdminComponents/AsideLeft";
import { GetById, GetSellerById } from "../services/seller.service";
import { GetCustomer } from "../services/customer.service";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import formatMoney from "../helpers/money.helper";
import { useLocation, useParams } from "react-router-dom";
import { getuser } from "../helpers/user.helper";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
var Barcode = require("react-barcode");

export default function VendaDetail(props) {
  const [itensVenda, setItensVenda] = useState(undefined);
  const [venda, setVenda] = useState(undefined);

  let { id } = useParams();

  const {state} = useLocation();

  useEffect(() => {
    async function fetchData() {
      let { venda } = state;
      let result = await GetById(id);
      let resultVenda = await GetSellerById(id);
      let customer = await GetCustomer(resultVenda?.data.codCliente);
      setVenda(venda);
      setItensVenda({ vendaItens: result?.data, cliente: customer?.data[0] });
    }

    fetchData();
  }, [id, state]);

  const barcodeLine = (rowData, column) => {
    return (
      <div>
        <Barcode
          value={rowData.codProduto}
          height={10}
          fontSize={12}
          displayValue={false}
        />
      </div>
    );
  };

  const getTotal = (total, num, qtd) => {
    let preco = parseFloat(num.valor);
    return total + Math.round(preco);
  };

  const getComissao = () => {
    if (
      itensVenda &&
      itensVenda.vendaItens &&
      itensVenda.vendaItens.length > 0
    ) {
      let total = itensVenda.vendaItens.reduce(getTotal, 0);
      return (30 * total) / 100;
    }
  };

  const getTotalPago = () => {
    if (
      itensVenda &&
      itensVenda.vendaItens &&
      itensVenda.vendaItens.length > 0
    ) {
      let total = itensVenda.vendaItens.reduce(getTotal, 0);
      return total - (30 * total) / 100;
    }
  };

  let renderHeader = () => {
    return (
      <div className="table-header">
        Cliente {itensVenda?.cliente?.codigo} - {itensVenda?.cliente?.nome}
      </div>
    );
  };

  let renderFooter = () => {
    return (
      <div className="table-footer text-right">
        <p>
          {getuser().type === "C" ? "Total Compra:" : "Total Venda:"}{" "}
          {formatMoney(venda?.total || 0)}
        </p>
        <p>Total Desconto: {formatMoney(getComissao() || 0)}</p>
        <p>Total Pago: {formatMoney(getTotalPago() || 0)}</p>
      </div>
    );
  };

  let renderLoad = () => {
    return (
      <div className="table-footer text-center">
        <Loader
          type="ThreeDots"
          color="#343A40"
          height={100}
          width={100}
          visible={true}
        />
      </div>
    );
  };

  return (
    <>
      <div className="wrapper">
        {/* Navbar */}
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
          <NavBarNotificationBar />
        </nav>
        <AsideLeft option="vendas" />
        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0 text-dark">
                    {getuser().type === "C" ? "Compra" : "Venda"} {id}
                  </h1>
                </div>
              </div>
            </div>
          </div>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                {/* Left col */}
                <section className="col-lg-12 connectedSortable">
                  {/* Custom tabs (Charts with tabs)*/}
                  <div className="card">
                    <div className="card-body">
                      {!itensVenda?.vendaItens ? (
                        renderLoad()
                      ) : (
                        <div className="tab-content p-0">
                          <DataTable
                            header={renderHeader()}
                            footer={renderFooter()}
                            exportable={true}
                            value={itensVenda?.vendaItens}
                            style={{ marginBottom: 50 }}
                            responsive
                            className="p-datatable-customers"
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
                            emptyMessage="Buscando Itens"
                          >
                            <Column
                              field="codProduto"
                              header="Produto"
                              exportable={true}
                            />
                            <Column
                              field="descricao"
                              header="Descrição"
                              exportable={true}
                            />
                            <Column
                              field="garantia"
                              header="Garantia"
                              exportable={true}
                            />
                            <Column
                              field="cpfGarantia"
                              header="Cpf Garantia"
                              exportable={true}
                            />
                            <Column
                              field="emailGarantia"
                              header="Email Garantia"
                              exportable={true}
                            />
                            <Column
                              key="123"
                              body={barcodeLine}
                              bodyStyle={{
                                textAlign: "center",
                                overflow: "hidden",
                              }}
                              exportable={true}
                            />
                          </DataTable>
                        </div>
                      )}
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </section>
        </div>

        <footer className="main-footer">
          <strong>
            Copyright © 2020 <a href="http://hondix.com.br">Hondix</a>.
          </strong>
          <div className="float-right d-none d-sm-inline-block">
            <b>Version</b> 1.0.0
          </div>
        </footer>
        <aside className="control-sidebar control-sidebar-dark"></aside>
      </div>
    </>
  );
}
